import styled from "../styles";

export const NotificationIndicator = styled.span`
  height: ${(p) => p.theme.spacing.m};
  width: ${(p) => p.theme.spacing.m};
  line-height: 1;
  padding: 3px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${(p) => p.theme.typography.size.xxs};
  border-radius: 100%;
  margin-left: auto;
  color: #fff;
  font-weight: ${(p) => p.theme.typography.weight.bold};
  background-color: ${(p) => p.theme.color.primary};
`;

export const NotificationIndicatorWhite = styled(NotificationIndicator)`
  color: ${(p) => p.theme.color.primary};
  font-weight: ${(p) => p.theme.typography.weight.bold};
  background-color: #fff;
`;
